// src/components/StudentToolLinks.jsx
//
// PLAN S11b: quick-links for the four tools on the student dashboard.
// Audit finding: no reusable sidebar/nav pattern is actually in use
// (components/menu.jsx's flowbite-react Sidebar is imported nowhere), so
// this is a fresh, small nav strip rather than reviving that dead code.
// lucide-react icons, matching StudentProgram.jsx and login.jsx.
//
// Direct tool routes (/budget/:projectId, /location/:projectId, ...) need a
// project first, which the dashboard doesn't have in hand - so "Start a new
// project" and "My projects" are the two real entry points, and the four
// tool cards link to each tool's existing HowTo page (no project required)
// rather than a dead-end bare tool route.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Wallet, Users, MapPin, Plus, FolderOpen } from 'lucide-react';

const TOOLS = [
  { key: 'script', label: 'Script Analysis', icon: FileText, href: '/SAHowTo' },
  { key: 'budget', label: 'Budgeting', icon: Wallet, href: '/budgetHowTo' },
  { key: 'casting', label: 'Casting Assistant', icon: Users, href: '/castHowTo' },
  { key: 'location', label: 'Location Scouting', icon: MapPin, href: '/locationHowTo' },
];

const StudentToolLinks = () => {
  const navigate = useNavigate();

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 mb-6">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <p className="font-semibold text-slate-800">Your tools</p>
        <div className="flex gap-2">
          <button
            onClick={() => navigate('/starter')}
            className="flex items-center gap-1.5 text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 rounded-full px-4 py-2 transition-colors"
          >
            <Plus size={16} /> Start a new project
          </button>
          <button
            onClick={() => navigate('/myprojects')}
            className="flex items-center gap-1.5 text-sm font-medium text-teal-700 border border-teal-300 hover:bg-teal-50 rounded-full px-4 py-2 transition-colors"
          >
            <FolderOpen size={16} /> My projects
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {TOOLS.map(({ key, label, icon: Icon, href }) => (
          <button
            key={key}
            onClick={() => navigate(href)}
            className="flex flex-col items-center gap-2 rounded-xl border border-slate-200 hover:border-teal-400 hover:bg-teal-50 hover:shadow-sm p-4 transition-all text-center"
          >
            <span className="w-9 h-9 rounded-full flex items-center justify-center bg-teal-600/10 text-teal-600">
              <Icon size={18} />
            </span>
            <span className="text-xs font-medium text-slate-700">{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StudentToolLinks;
